import { render, staticRenderFns } from "./step-complete.vue?vue&type=template&id=0aae61e3&scoped=true&"
import script from "./step-complete.vue?vue&type=script&lang=js&"
export * from "./step-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aae61e3",
  null
  
)

export default component.exports